import styled from 'styled-components';
import { container } from 'styles/grid';
import {
  spacer16,
  spacer24,
  spacer80,
  spacer64,
  spacer48,
  spacer8,
  spacer6,
  spacer1,
} from 'styles/spacers';
import { minWidth, maxWidth } from 'styles/media-queries';
import { black, darkGray, white } from 'styles/colors';
import { fontWeights } from 'styles/variables';
import { levels } from 'styles/z-index';
import { Icon } from 'components/atoms/icon';
import { red25 } from '@spotify-internal/encore-web/core';

export const Container = styled.section`
  background-color: ${black};
  position: relative;
  z-index: ${levels.base};
  padding-bottom: ${spacer48};
  ${minWidth.lg`
    padding-bottom: ${spacer80};
  `}
`;

export const Content = styled.div`
  ${container}
`;

export const Background = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacer1};
  background-color: ${darkGray};
  border-radius: 8px;
  position: relative;
`;

export const ErrorBanner = styled.div`
  background-color: ${red25};
  color: ${white};
  padding: ${spacer8};
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  gap: ${spacer16};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const ErrorIcon = styled(Icon)`
  width: 2.2rem;
  height: 2.2rem;
  line-height: 2.2rem;

  svg,
  div {
    height: inherit;
    width: inherit;
  }
  path {
    fill: ${white};
  }
`;

export const ErrorMessage = styled.p`
  font-size: 1.4rem;
  font-weight: ${fontWeights.normal};
  line-height: 1.6rem;
`;

export const ContentBackground = styled.div`
  display: flex;
  flex-direction: column-reverse;
  padding: ${spacer64} ${spacer16};
  gap: ${spacer48};
  position: relative;

  ${minWidth.xl`
    flex-direction: row;
    gap: ${spacer64};
    padding: ${spacer80} ${spacer64};
  `}
`;

export const FormInputs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacer24};

  ${minWidth.xl`
    width: 612px;
    max-height: 692px;
    overflow-y: auto;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;
export const ScrollableFormInputs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacer24};

  ${minWidth.xl`
    width: 612px;
    max-height: 626px;
    overflow-y: auto;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const MessageField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacer8};
`;

export const MessageFieldLabel = styled.div`
  font-size: 1.4rem;
  color: ${white};
`;

export const Output = styled.div`
  width: 100%;
  background-color: transparent;

  ${minWidth.xl`
    width: 100%;
  `}
`;

export const GenerateButton = styled.button<{
  disabled?: boolean;
}>`
  width: 25%;
  padding: ${spacer16} ${spacer24};
  background: ${white};
  color: ${black};
  border: none;
  border-radius: ${spacer6};
  font-size: 1.6rem;
  font-weight: ${fontWeights.extra_bold};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  ${maxWidth.lg`
  width: 100%;
`}

  &:disabled {
    cursor: not-allowed;
  }
`;
